export const FETCH_FIRST_CARDS_QUANTITY = 10
